export default "__VITE_ASSET__Cz762n$R__"